import { HydrationOverlay } from "@builder.io/react-hydration-overlay";
import type { EmotionCache } from "@emotion/react";
import type { AppProps } from "next/app";
import AppCore from "./AppCore";

export function AppWithHydrationOverlay(
  props: AppProps & { emotionCache?: EmotionCache }
) {
  return (
    <HydrationOverlay>
      <AppCore {...props} />
    </HydrationOverlay>
  );
}
